import React, { useEffect, useState } from 'react';

interface Answer {
  id: string;
  participantsName: string;
  answerValue: string;
  isAnswer: boolean;
  answerCount: number;
}

interface Question {
  question: string;
  id: string;
  answer: Answer[];
  allowMultipleVoting: boolean;
  keepResponsesAnonymous: boolean;
}

interface Participant {
  submittedPoll: boolean;
}

interface ActivityData {
  title: string;
  description: string;
  duration: string;
  duration_in_days: string;
  submission_date: string;
  questions: Question[];
  participants: Participant[];
  status: string;
  submittedParticipants: number,
  totalParticipants: number,
  keepResponsesAnonymous: boolean,
  allowMultipleVoting: boolean,
}

interface PollResultProps {
  activityData: any;
}

const PollResult: React.FC<PollResultProps> = ({ activityData }) => {
  console.log("activityData:", activityData);
  const [selectedQuestion, setSelectedQuestion] = useState<Question | null>(null);

  useEffect(() => {
    if (activityData?.questions?.length > 0 && !selectedQuestion) {
      setSelectedQuestion(activityData.questions[0]);
    }
  }, [activityData.questions, selectedQuestion]);

  const handleQuestionClick = (question: Question) => {
    setSelectedQuestion(question);
  };

  const calculateSubmissionInfo = (question: Question | null) => {
    if (!question || !activityData || !activityData.participants) {
      return null;
    }

    const totalParticipants = activityData.totalParticipants || 0;
    const submittedParticipants = activityData.submittedParticipants || 0;
    const percentage = totalParticipants > 0 ? (submittedParticipants / totalParticipants) * 100 : 0;

    return (
      <div className="flex flex-row justify-between items-center">
        {/* <div className="flex items-start self-start">
          {submittedParticipants}/{totalParticipants} Responses
        </div> */}
        {/* <div className="flex items-end self-end">
          {percentage.toFixed(0)}%
        </div> */}
      </div>
    );
  };

  return (
    <div className="">
      <div className="rounded-xl flex items-center justify-between">
        <div
          className={`w-1/4 mobile:w-1/4 laptop:w-1/5 text-white ${activityData.status === 'Live' ? 'bg-green-600' : activityData.status === 'Closed' ? 'bg-red-600' : 'bg-gray-600'
            } rounded-tl-xl text-center font-bold p-2`}
        >
          {activityData.status || 'Unknown'}
        </div>
        <div className="w-3/4 mobile:w-3/4 laptop:w-4/5 bg-app-yellow rounded-tr-xl text-start font-bold p-2 px-8 text-app-gray-medium">
          {activityData.title || 'No Title'}
        </div>
      </div>
      <div className="flex flex-row mobile:flex-col p-4 mt-2">
        <div className="mr-10 mobile:w-full w-1/3">
          {activityData?.questions?.length > 0 ? (
            activityData.questions.map((q: Question, index: number) => (
              <button
                key={q.id}
                className={`text-app-blue rounded-lg p-2 mb-2 w-full font-bold ${selectedQuestion?.id === q.id ? 'bg-[#E9E0FA] text-app-blue' : 'bg-[#D4D6DB] text-app-gray-medium'
                  }`}
                onClick={() => handleQuestionClick(q)}
              >
                Question {index + 1}
              </button>
            ))
          ) : (
            <div className="text-app-gray-medium">No questions available</div>
          )}
        </div>
        <div className="w-full">
          {selectedQuestion ? (
            <div className="mb-4">
              <h3 className="text-xl font-semibold mb-2 text-app-gray-medium">{selectedQuestion.question}</h3>
              <div className="flex flex-row justify-start gap-4 items-start text-app-blue font-bold">
                <div>{selectedQuestion.keepResponsesAnonymous ? 'Anonymous Responses' : ''}</div>
                <div>{selectedQuestion.allowMultipleVoting ? 'Multi-choice Responses' : ''}</div>
              </div>
              {calculateSubmissionInfo(selectedQuestion)}
              <div className="flex flex-col">
                {selectedQuestion.answer.map((a: Answer) => (
                  <div
                    key={a.id}
                    className="flex flex-row justify-evenly items-baseline shadow-2xl p-6 gap-2 mb-2 w-full rounded-3xl bg-white"
                  >

                    <div className="flex-1 text-left font-semibold text-app-gray-medium">
                      {a.answerValue}
                    </div>

                    <div className="flex-none text-xs text-center font-light px-4">
                      {a.answerCount} / {activityData.submittedParticipants} Responses
                    </div>

                    <div className="flex-1 text-right text-2xl font-bold text-[#5F488A]">
                      {activityData.submittedParticipants > 0
                        ? ((a.answerCount / activityData.submittedParticipants) * 100).toFixed(0)
                        : 0}
                      %
                    </div>

                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="text-app-gray-medium">Select a question to view details</div>
          )}
        </div>
      </div>
    </div>
  );
};
export default PollResult;